export const language = {
	label: 'v.',
};
